export const PAGES = [
    {
        id:"about",
        path:"/aboutus",
        name:"About Us",
    },
    {
        id:"categories",
        path:"/categories",
        name:"Categories",
    },
    {
        id:"contact",
        path:"/contact",
        name:"Contact",
    },
];